module.exports = __webpack_public_path__ + "static/media/hand_lettered_restaurant_menu_background_2018.26a37b70.webp";